import Marquee from "react-fast-marquee";

const WORDS = [
  "Pre-Workout Energy",
  "Post-Workout Recovery",
  "Full Macro Transparency",
  "Custom Shakes",
  "Build-Your-Own Meals",
  "Ready-To-Drink",
];

export default function EditorialMarquee() {
  return (
    <div data-testid="marquee" className="bg-coffee py-5 border-y border-coffee-soft">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w) => (
          <span key={w} className="mx-8 inline-flex items-center gap-8 font-display text-2xl sm:text-3xl italic text-beige">
            {w}
            <span className="text-amber-brand not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
